import type { NextPage } from 'next';
import { DocumentRenderer } from '@keystone-6/document-renderer';
import PageTemplate from './page.template';
import Container from '../components/container/container.component';
import Gallery from '../components/gallery/gallery.component';
import Image from 'next/image';
import styles from '../styles/[page].module.scss';
import { PostProps } from '../types/post-props.interface';

interface Props extends PostProps {}

const PostPage: NextPage<Props> = ({ menu, options, post }) => (
  <PageTemplate
    options={options}
    menu={menu}
    title={post.title}
    description={post.description}
  >
    <Container
      css={{ height: 'auto', minHeight: 'calc(100vh - 240px)' }}
      column={true}
    >
      <article className={styles.content}>
        <h1>{post.title}</h1>
        {post.image && (
          <section className={styles.imageWrapper}>
            <Image
              src={`http://localhost:5000${post.image.url}`}
              alt={post.title}
              height={post.image.height}
              width={post.image.width}
            />
          </section>
        )}
        <h5 style={{ textAlign: 'right', margin: '10px 0' }}>
          Created at {new Date(post.createdAt).toLocaleDateString('pl')} by{' '}
          {post.author.name} in{' '}
          {post.category.name.substr(0, 1).toLocaleUpperCase()}
          {post.category.name.substr(1)}
        </h5>
        <DocumentRenderer document={post.content.document} />
        {post.gallery && post.gallery.length > 0 && (
          <Gallery
            simple={post.slug === 'financing'}
            images={post.gallery.map((img) => ({
              id: img.id,
              url: img.image.url,
              title: img.alt,
              width: img.image.width,
              height: img.image.height,
            }))}
          />
        )}
      </article>
    </Container>
  </PageTemplate>
);

export default PostPage;
